import { expiryLabel, fmtSize, fmtWhen } from "../../lib/backups";

const TONE = {
  ready:   "bg-grass/15 text-grass ring-grass/30",
  failed:  "bg-scarlet/15 text-scarlet ring-scarlet/30",
  running: "bg-cobalt/15 text-cobalt ring-cobalt/30",
};

const Th = ({ children, className = "" }) => (
  <th className={`px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-[0.18em] text-olive ${className}`}>{children}</th>
);

const sentTo = (r) => r.email_sent_to || (typeof r.email_to === "string" && r.email_sent_at ? [r.email_to] : []);

/** One row per run: when, kind, status, size, downloads, expiry, recipients. */
export const BackupTable = ({ rows }) => (
  <div className="overflow-x-auto rounded-xl border border-border bg-bone" data-testid="backup-table">
    <table className="w-full min-w-[720px] border-collapse text-sm">
      <thead className="border-b border-border">
        <tr>
          <Th>Taken</Th><Th>Kind</Th><Th>Status</Th><Th className="text-right">Size</Th><Th className="text-right">Collections</Th>
          <Th className="text-right">Downloads</Th><Th>Link</Th><Th>Emailed to</Th>
        </tr>
      </thead>
      <tbody className="divide-y divide-ink/8">
        {rows.map((r) => {
          const sent = sentTo(r);
          const errs = Object.keys(r.email_errors || {});
          const expired = r.expires_at && new Date(r.expires_at) < new Date();
          return (
            <tr key={r.backup_id} data-testid={`backup-row-${r.backup_id}`} className="align-top">
              <td className="whitespace-nowrap px-3 py-2.5 text-ink">{fmtWhen(r.created_at)}</td>
              <td className="px-3 py-2.5 capitalize text-olive">{r.kind}</td>
              <td className="px-3 py-2.5">
                <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] ring-1 ring-inset ${TONE[r.status] || "bg-ink/10 text-ink ring-ink/20"}`} data-testid={`backup-row-status-${r.backup_id}`}>
                  {r.status}
                </span>
                {r.error && <p className="mt-1 max-w-xs text-xs text-scarlet">{r.error}</p>}
              </td>
              <td className="whitespace-nowrap px-3 py-2.5 text-right text-ink">{fmtSize(r.size_bytes)}</td>
              <td className="px-3 py-2.5 text-right text-ink">{r.collections ?? "—"}</td>
              <td className="px-3 py-2.5 text-right">
                <span className="text-ink">{r.downloads ?? 0}</span>
                {r.last_downloaded_at && <p className="text-[11px] text-olive">last {fmtWhen(r.last_downloaded_at)}</p>}
              </td>
              <td className={`whitespace-nowrap px-3 py-2.5 ${expired ? "text-olive" : "text-ink"}`}>{r.status === "ready" ? expiryLabel(r.expires_at) : "—"}</td>
              <td className="px-3 py-2.5 text-xs text-olive">
                {sent.length ? sent.join(", ") : r.status === "ready" ? <span className="text-scarlet">nobody (email failed)</span> : "—"}
                {errs.length > 0 && <p className="text-scarlet">failed: {errs.join(", ")}</p>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);
